export default __webpack_public_path__ + "monitoring.html";